import { Point } from "../models/point";

export const type = 'horizontal';

export const tableOffsetTop = 160;
export const tableShadowOffsetTop = 280;
export const tableLogoOffsetTop = 300;
export const tableTextOffsetTop = 95; // offset from Logo

export const gameWidth = 1920;
export const gameHeight = 930;


export const tablePotTotal = {
    "x": 960,
    "y": 295
}; 
export const tableCommunityCardScale = 0.9;

export const tripleDrawRoundInfo = { y: 365 };

// ==============================================
// =============== SEATS POSITIONS =============== 
// ==============================================

export const SeatPositions: Point[] = [
    { x: 556, y: 67 },
    { x: 896, y: 67 },
    { x: 1255, y: 67 },


    { x: 1567, y: 237 },
    { x: 1567, y: 567 },

    { x: 1255, y: 738 },
    { x: 896, y: 738 },
    { x: 556, y: 738 },

    { x: 223, y: 567 },
    { x: 223, y: 237 },
];


export const SeatPositionsFor6Players: Point[] = [
    { x: 356, y: 118 },
    { x: 895, y: 70 },
    { x: 1434, y: 118 },
    { x: 0, y: 0 },
    { x: 0, y: 0 }, // center
    { x: 1434, y: 693 },
    { x: 895, y: 736 },
    { x: 356, y: 693 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
];


export const SeatsVisibility = { // <======================================== 📖 its not used
    0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 0 players - NOT POSSIBLE
    1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 player - NOT POSSIBLE
    2: [0, 1, 0, 0, 0, 0, 1, 0, 0, 0], // 2 players
    3: [0, 0, 0, 1, 0, 0, 1, 0, 0, 1], // 3 players
    4: [0, 1, 0, 1, 0, 0, 1, 0, 0, 1], // 4 players
    5: [1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // 5 players
    6: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0], // 6 players
    7: [1, 0, 1, 1, 0, 1, 1, 1, 0, 1], // 7 players
    8: [1, 1, 1, 1, 0, 1, 1, 1, 1, 0], // 8 players
    9: [1, 0, 1, 1, 1, 1, 1, 1, 1, 1], // 9 players
    10: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]  // 10 players
};

export const SeatsVisibilityWithDealer = {
    0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 0 players - NOT POSSIBLE
    1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 player - NOT POSSIBLE
    2: [0, 1, 0, 0, 0, 0, 1, 0, 0, 0], // 2 players
    3: [0, 0, 0, 1, 0, 0, 1, 0, 0, 1], // 3 players
    4: [0, 1, 0, 1, 0, 0, 1, 0, 0, 1], // 4 players
    5: [1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // 5 players
    6: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0], // 6 players
    7: [1, 0, 1, 1, 1, 0, 1, 0, 1, 1], // 7 players
    8: [1, 1, 1, 0, 1, 1, 1, 1, 1, 0], // 8 players
    9: [1, 0, 1, 1, 1, 1, 1, 1, 1, 1], // 9 players
    10: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]  // 10 players
};



// =================================================
// =============== PLAYERS POSITIONS =============== 
// =================================================


export const PlayerPositions: Point[] = [
    {
        "x": 435,
        "y": 0
    },
    {
        "x": 787,
        "y": 30
    },
    {
        "x": 1143,
        "y": 0
    },
    {
        "x": 1485,
        "y": 156
    },
    {
        "x": 1514,
        "y": 465
    },
    {
        "x": 1143,
        "y": 630
    },
    {
        "x": 787,
        "y": 630
    },
    {
        "x": 435,
        "y": 630
    },
    {
        "x": 49,
        "y": 465
    },
    {
        "x": 45,
        "y": 158
    }
]

export const PlayerPositionsFor6Players: Point[] = [
    {
        "x": 243,
        "y": 55
    },
    {
        "x": 786,
        "y": 30
    },
    {
        "x": 1322,
        "y": 55
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 1322,
        "y": 630
    },
    {
        "x": 786,
        "y": 630
    },
    {
        "x": 243,
        "y": 630
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 0,
        "y": 0
    }
]


// =============================================================
// =============== PLAYERS FOLDED CARDS POSITIONS =============== 
// ==============================================================

// 📚 Foled cards positions go slightly up than setted Y position

export const FoldedCardsPositions: Point[] = [
    {
        "x": 696,
        "y": 267
    },
    {
        "x": 1112,
        "y": 268
    },
    {
        "x": 1229,
        "y": 290
    },
    {
        "x": 1487,
        "y": 406
    },
    {
        "x": 1539,
        "y": 509
    },
    {
        "x": 1235,
        "y": 678
    },
    {
        "x": 1020,
        "y": 682
    },
    {
        "x": 657,
        "y": 682
    },
    {
        "x": 432,
        "y": 624
    },
    {
        "x": 376,
        "y": 361
    }
]
export const FoldedCardsPositionsFor6Players: Point[] =[
    {
        "x": 575,
        "y": 287
    },
    {
        "x": 1145,
        "y": 308
    },
    {
        "x": 1498,
        "y": 389
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 1348,
        "y": 650
    },
    {
        "x": 849,
        "y": 661
    },
    {
        "x": 435,
        "y": 596
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 0,
        "y": 0
    }
]


// ==============================================================
// =============== TABLE CARDS  =================================
// ==============================================================

export const CommunityCardPositions: Point[] = [
    { x: 736, y: 425 },
    { x: 818, y: 425 },
    { x: 900, y: 425 },
    { x: 982, y: 425 },
    { x: 1064, y: 425 }
];
export const R2tT1Positions: Point[] = [
    { x: 736, y: 368 }, // 900 - 2 * 82
    { x: 818, y: 368 }, // 900 - 1 * 82
    { x: 900, y: 368 }, // center
    { x: 982, y: 368 }, // 900 + 1 * 82
    { x: 1064, y: 368 } // 900 + 2 * 82
];
export const R2tT2Positions: Point[] = [
    { x: 736, y: 482 }, // 900 - 2 * 82
    { x: 818, y: 482 }, // 900 - 1 * 82
    { x: 900, y: 482 }, // center
    { x: 982, y: 482 }, // 900 + 1 * 82
    { x: 1064, y: 482 } // 900 + 2 * 82
];
// export const R2tCardScale: Point = { x: 1.1, y: 1.1 };
// export const CommunityCardScale: Point = { x: 1.35, y: 1.35 };


// ==============================================================
// =============== POT POSITIONS  =================================
// ==============================================================


export const PotPositions: Point[] = [
    {
        "x": 561,
        "y": 299
    },
    {
        "x": 1040,
        "y": 304
    },
    {
        "x": 1279,
        "y": 301
    },
    {
        "x": 1394,
        "y": 374
    },
    {
        "x": 1389,
        "y": 518
    },
    {
        "x": 1255,
        "y": 622
    },
    {
        "x": 1027,
        "y": 635
    },
    {
        "x": 547,
        "y": 619
    },
    {
        "x": 365,
        "y": 567
    },
    {
        "x": 374,
        "y": 313
    }
]

export const PotPositionsFor6Players: Point[] = [
    {
        "x": 557,
        "y": 231
    },
    {
        "x": 1097,
        "y": 247
    },
    {
        "x": 1381,
        "y": 354
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 1399,
        "y": 622
    },
    {
        "x": 1033,
        "y": 635
    },
    {
        "x": 484,
        "y": 651
    },
    {
        "x": 0,
        "y": 0
    },
    {
        "x": 0,
        "y": 0
    }
]


export const MainPotPositions: Point[] = [
    {
        "x": 640,
        "y": 448
    }, //@MainPot 1 center
    {
        "x": 640,
        "y": 505
    } //@MainPot 2 
];



export const flyingTableCard = { x: 960, y: 295 };
